function bloquearDetalles() {
    document.querySelectorAll('.js-collection-acordeon_footer').forEach(function (el) {
        if (window.innerWidth >= 750) {
            el.setAttribute('open', '');
            el.classList.add('bloqueado');

            // Previene que el usuario cierre el details
            el.querySelector('summary').addEventListener('click', function (e) {
            e.preventDefault();
            });
        } else {
            el.classList.remove('bloqueado');
        }
    });
}

window.addEventListener('DOMContentLoaded', bloquearDetalles);
window.addEventListener('resize', bloquearDetalles);
